export default function inputsValidation(errors: any, inputName: string): string {
  if (errors[inputName]) {
    switch (errors[inputName].type) {
      case "required":
        return "To pole jest wymagane!";
      case "pattern":
        return errors[inputName].message;
      default:
        return errors[inputName].message ? errors[inputName].message : "Błędnie wypełnione pole!";
    }
  }
  return "";
}
